module.exports = __webpack_public_path__ + "img/10.d560264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/10.png
// module id = BalY
// module chunks = 1